import { __awaiter, __generator } from "tslib";
import { useEffect, useState, useCallback } from 'react';
import { getModule } from '@scalprum/core';
export function useModule(scope, module, defaultState, importName) {
    var _this = this;
    if (importName === void 0) { importName = 'default'; }
    var _a = useState(defaultState), data = _a[0], setData = _a[1];
    var fetchModule = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var Module_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getModule(scope, module, importName)];
                case 1:
                    Module_1 = _a.sent();
                    setData(function () { return Module_1; });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [scope, module]);
    useEffect(function () {
        fetchModule();
    }, [scope, module, importName]);
    return data;
}
//# sourceMappingURL=use-module.js.map